<template>
  <div
    @click="$emit('click')"
    class="burger-button"
  >
    <div
      class="burger"
      :class="{ dark: isDark }"
    >
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BurgerButton',
  props: {
    isDark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .burger-button {
    width: 18px;
    height: 16px;
    cursor: pointer;
    padding: 0;
  }
  .burger {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: 100%;
    height: 100%;
    color: #fff;
    span,
    &::before,
    &::after {
      content: "";
      background-color: currentColor;
      width: 100%;
      height: 3px;
      top: 0;
      left: 0;
    }
  }
  .burger.dark {
    color: var(--text-main-color);
  }
</style>
